import React from "react";
import SidebarMenuItem from "../navigation/SidebarMenuItem";
import SidebarSubMenuItem from "./SidebarSubMenuItem";
import useWindowDimensions from "../../helper/useWindowDimensions";
import { classNames } from "../../helper/classNames";
import Button from "../form/Button";

const SidebarMenuBlocks = ({
  menuTitle,
  menuData,
  isMenuOpen,
  setIsMenuOpen,
  submenuToggleMenu,
  getActionValue = () => {},
  ...props
}) => {
  const { width } = useWindowDimensions();

  return (
    <>
      {!props.isHidden && (
        <div
          className={classNames(
            "relative space-y-2 transition-all duration-100",
            width > 1024 ? (isMenuOpen ? "px-2" : "px-4") : "px-2",
            menuTitle !== '' && 'py-4' 
          )}
        >
          {width > 1024 ? (
            !isMenuOpen && (
              <div className={"text-xs uppercase text-slate-500 font-medium"}>
                {menuTitle}
              </div>
            )
          ) : (
            <div className={"text-xs uppercase text-slate-500 font-medium"}>
              {menuTitle}
            </div>
          )}
          <div className="space-y-1">
            {/* {menuData.map((item, index) => (
                <SidebarMenuItem key={item._id} index={index} isStepMenu={item.isStepMenu} menuLink={item.menuLink} menuIcon={item.menuIcon} menuIconColor={item.menuIconColor} menuLabel={item.menuLabel} isMenuOpen={isMenuOpen} isLocked={item.isLocked}/>
              ))} */}
            {menuData.length > 0 &&
              menuData
                ?.map((item, index) =>
                  item.menuIsLink ? (
                    <SidebarMenuItem
                      key={item._id}
                      index={index}
                      isStepMenu={item.isStepMenu}
                      menuLink={item.menuLink}
                      menuIcon={item.menuIcon}
                      menuIconColor={item.menuIconColor}
                      menuLabel={item.menuLabel}
                      isMenuOpen={isMenuOpen}
                      setIsMenuOpen={setIsMenuOpen}
                      isLocked={item.isLocked}
                      menuIsDisabled={item?.menuIsDisabled}
                    />
                  ) : item?.isButton ? (
                    <Button
                      buttonType={"button"}
                      buttonIcon={"fa-light " + item?.menuIcon}
                      buttonClasses={
                        item?.menuIsDisabled
                          ? "!w-full !h-12 !bg-gray-400 !flex !justify-start"
                          : "!w-full !h-12 blob !flex !justify-start"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={item?.menuLabel}
                      buttonLabelClasses={"!whitespace-normal !text-left"}
                      buttonHasLink={false}
                      buttonDisabled={
                        item?.menuIsDisabled ? item?.menuIsDisabled : false
                      }
                      //buttonLink={"/add-executive"}
                      functions={(e) => {
                        if (!item?.menuIsDisabled) {
                          getActionValue(e, item?.isButtonType);
                        }
                      }}
                    />
                  ) : (
                    <SidebarSubMenuItem
                      key={item._id}
                      isStepMenu={item.isStepMenu}
                      menuIcon={item.menuIcon}
                      menuIconColor={item.menuIconColor}
                      submenuData={item.submenuData}
                      menuLabel={item.menuLabel}
                      isMenuOpen={isMenuOpen}
                      setIsMenuOpen={setIsMenuOpen}
                      isCollapse={item.isCollapse}
                      submenuToggleMenu={submenuToggleMenu}
                      menuIsDisabled={item?.menuIsDisabled}
                    />
                  )
                )
                .filter((item) => item)}
          </div>
        </div>
      )}
    </>
  );
};

export default SidebarMenuBlocks;
